<script setup lang="ts">
import type { Dayjs } from 'dayjs';

interface IDatePickerProps {
  minDate: Dayjs;
  maxDate: Dayjs;
}
withDefaults(defineProps<IDatePickerProps>(), {
  maxDate: null,
  minDate: null,
});
const { $t } = useNuxtApp();
const dateRange = defineModel<{ startDate: Dayjs; endDate: Dayjs }>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-base-priority text-xs capitalize">
      {{ $t('filter-by-date-range') }}
    </span>
    <DesignSystemInputsDatePicker
      v-model:date="dateRange"
      mode="range"
      :max-date="maxDate"
      :min-date="minDate"
    />
    <slot name="date-range-buttons" />
  </div>
</template>
